import InternalRadio from './radio';
import Group from './group';
import Button from './radio-button';
var Radio = InternalRadio;
Radio.Group = Group;
Radio.Group.displayName = 'RadioGroup';
Radio.Button = Button;
export { Group, Button };
export default Radio;